import { combineReducers } from 'redux';
import navigationReducer from './navigationReducer';
import eligibilityReducer from './eligibilityReducer';
import sessionTimeoutReducer from './sessionTimeoutReducer';
import applicationSubmitReducer from './applicationSubmitReducer';
import productSelectionReducer from './productSelectionReducer';
import customerReducer from './customerReducer';
import formValuesReducer from './formValuesReducer';
import analyticsReducer from './analyticsReducer';
import applicationDataReviewReducer from './applicationDataReviewReducer';
import accountListReduer from './accountListReduer';

export default combineReducers({
  navigation: navigationReducer,
  eligibility: eligibilityReducer,
  applicationSubmitResponse: applicationSubmitReducer,
  sessionTimeout: sessionTimeoutReducer,
  productSelection: productSelectionReducer,
  formValues: formValuesReducer,
  customer: customerReducer,
  analytics: analyticsReducer,
  appDataReview: applicationDataReviewReducer,
  accountList: accountListReduer,
  sessionId: (state = null) => state,
  queryParams: (state = null) => state,
});
